export const getIsOwner = (groupsDictionary, companyGroup) => {
    if (
        groupsDictionary &&
        companyGroup &&
        groupsDictionary[companyGroup] &&
        groupsDictionary[companyGroup].type === 0 &&
        groupsDictionary[companyGroup].owner_type === 0
    ) {
        return true;
    }
    return false;
};
